import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";
import {useEffect} from "react";
import { useNavigate } from "react-router-dom";

export default function Phone({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const navigate = useNavigate();

    useEffect(() => {
        if (flowData.phone || flowData.lastName) return;

        try {
            const saved = JSON.parse(
            localStorage.getItem("dys_last_customer_details") || "null"
            );

            if (saved?.phone && saved?.lastName) {
            updateFlowData({
                phone: /^\d{10}$/.test(saved.phone)
                ? saved.phone
                : "",
                lastName:
                typeof saved.lastName === "string"
                    ? saved.lastName
                    : "",
            });
            }
        } catch {
            // Ignore invalid saved data.
        }
        }, []);

    const isFormValid =
    flowData.phone.trim() !== "" &&
    flowData.lastName.trim() !== "";    

    const validate = () => {
        if (!flowData.phone.trim()) {
            return "Please enter your phone number.";
        }

        if (!flowData.lastName.trim()) {
            return "Please enter your last name.";
        }

        if (!/^\d{10}$/.test(flowData.phone)) {
            return "Please enter a valid 10-digit phone number.";
        }

        return false;

    };

    const continueToNext = () => {
        if (loading || !isFormValid) return;
        setError("");
        const error = validate();
        if (error) {
            alert(error);
            return;
        }        
        next({
            action: "submit_phone"
        });
    };
  

    const changeService = () => {
        if (loading) return;
        setError("");       
        navigate(
            `/start-waiver/${flowContext.businessLocationSlug}/${flowContext.businessTypeSlug}`
        );
    };

    const formatPhoneNumber = (value) => {
        const digits = (value || "").replace(/\D/g, "");
        if (digits.length <= 3) {
            return digits;
        }
        if (digits.length <= 6) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        }
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    };

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-header">

                <h2 className="business-name">
                   {flowContext.business?.businessName}
                </h2>

                <div className="selected-service">

                    <div className="selected-service-icon" />

                    <div className="selected-service-name">
                        {flowContext.selectedService?.name}
                    </div>

                    <button
                        className="change-service-btn"
                        type="button"
                        onClick={changeService}
                        disabled={loading}
                    >
                        Change service
                    </button>

                </div>

            </div>

            <div className="page-content">

                <h3 className="form-title">
                    Enter your details to continue
                </h3>

                <div className="form-group">

                    <label>
                        Phone Number
                    </label>

                    <input
                        type="tel"
                        value={formatPhoneNumber(flowData.phone)}
                        onChange={(e) => {
                            const digitsOnly = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);

                            updateFlowData({
                                phone: digitsOnly,
                            });
                        }}
                        placeholder="(555) 123-4567"
                        disabled={loading}
                    />

                </div>

                <div className="form-group">

                    <label>
                        Last Name
                    </label>

                    <input
                        type="text"
                        value={flowData.lastName}
                        onChange={(e) =>
                            updateFlowData({
                                lastName: e.target.value,
                            })
                        }
                        placeholder="Enter your last name"
                        disabled={loading}
                    />

                </div>

            </div>

            <div className="page-footer">

                {/*<button className="back-button" onClick={goBack} disabled={loading} >
                    Back
                </button>*/}
                
                
                
                <button
                    className="primary-button"
                    onClick={continueToNext}
                    disabled={loading || !isFormValid}
                >
                    Continue
                    <span className="button-arrow">›</span>
                </button>

                <div className="powered-by">
                    Powered by <strong>DidYouSign</strong>
                </div>

            </div>

        </div>
    );
}